import React from 'react';
import Button from 'react-bootstrap/Button';

export const CalendarHeader = ({ viewDate, onPrevMonth, onNextMonth, prevDisabled, nextDisabled }) => {
  return (
    <div className="header d-flex align-items-center justify-content-center gap-2 fw-semibold mb-2">
      <Button
        variant="light"
        size="sm"
        onClick={onPrevMonth}
        aria-label="Previous month"
        disabled={prevDisabled}
      >
        &lt;
      </Button>
      <span className="mx-2">
        {viewDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
      </span>
      <Button
        variant="light"
        size="sm"
        onClick={onNextMonth}
        aria-label="Next month"
        disabled={nextDisabled}
      >
        &gt;
      </Button>
    </div>
  );
};
